import { EDIT_ASYNC, SELECT_TOGGLE, STATUS_TOGGLE_ASYNC, TAG_REMOVE_ASYNC } from './constants'

const edit = (id) => ({ type: EDIT_ASYNC.INITIATE, payload: { id } })
const editCancel = () => ({ type: EDIT_ASYNC.CANCEL })
export const editSuccess = (data) => ({
  type: EDIT_ASYNC.SUCCESS,
  payload: { data },
})
export const editError = (error) => ({ type: EDIT_ASYNC.ERROR, error })

const toggleStatus = (id, status) => ({
  type: STATUS_TOGGLE_ASYNC.INITIATE,
  payload: { id, status },
})
const toggleStatusCancel = (id) => ({
  type: STATUS_TOGGLE_ASYNC.CANCEL,
  payload: { id },
})
export const toggleStatusSuccess = (data) => ({
  type: STATUS_TOGGLE_ASYNC.SUCCESS,
  payload: { data },
})
export const toggleStatusError = (error) => ({
  type: STATUS_TOGGLE_ASYNC.ERROR,
  error,
})

const toggleSelect = (id) => ({ type: SELECT_TOGGLE, payload: { id } })

const removeTag = (id, tagName) => ({
  type: TAG_REMOVE_ASYNC.INITIATE,
  payload: { id, tagName },
})
export const removeTagSuccess = (data) => ({
  type: TAG_REMOVE_ASYNC.SUCCESS,
  payload: { data },
})
export const removeTagError = (error) => ({
  type: TAG_REMOVE_ASYNC.ERROR,
  error,
})

export default {
  // to props
  edit,
  editCancel,
  toggleStatus,
  toggleStatusCancel,
  toggleSelect,
  removeTag,
}
